var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Archiv Erstellen'),"showDrawer":false,"lastPath":-1,"tooltipMessage":_vm.$t('Hier können Sie Archiv hinzufügen. Auch können Sie hier Ihre Aufgaben archivieren.')}}),_c('ArchiveAdd',{attrs:{"type":"ADD"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }